import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Helmet from "react-helmet";
import General from '../../modules/General';

class Settings extends React.Component {
	constructor(props) {
		super(props);
	}

	componentWillMount() {
		General.loadScript('https://js.stripe.com/v2/').then(() => Stripe.setPublishableKey(this.props.general.settings.stripe_key));
	}

	render() {


		
		return (
				<span>
				<Helmet 
					title="Billing | Crall.io"
				/>
				{this.props.children}
				</span>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general,
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


Settings = connect(mapStateToProps,mapDispatchToProps)(Settings);
export default Settings;


// WEBPACK FOOTER //
// ./containers/settings/Billing.js